// db.ts
import Dexie, { type EntityTable, type Table } from "dexie";
import type { Brand, ColumnInDB, Option, OptionGroup, UiField, UiTable } from "./types";

const dexie = new Dexie("PerforiaDatabase") as Dexie & {
	optionGroups: EntityTable<OptionGroup, "id">;
	options: Table<Option>;
	brands: EntityTable<Brand, "id">;
	uiTables: Table<UiTable>;
	uiFields: Table<UiField>;
	columnsInDB: Table<ColumnInDB>;
};

// Schema declaration:
dexie.version(1).stores({
	optionGroups: "id", // primary key: id
	options: "[id+optionGroupId], optionGroupId", // composite primary key: [id+optionGroupId], index on optionGroupId for lookups by group
	brands: "id", // primary key: id
	uiTables: "[schemaName+tableName]", // composite primary key matching ui_table_pk
	uiFields: "[schemaName+tableName+fieldName], [schemaName+tableName], optionGroupId, sectionId", // composite PK + useful indexes
	columnsInDB: "[schemaName+tableName+fieldName], [schemaName+tableName]",
});

export { dexie };
